<div class="language-container-store">
  <div class="language-store-header">
    <h1>{{'label.language' | translate}}</h1>
    <i class="icon-times" (click)="onClickAction()"></i>
  </div>
  <hr>

  <app-button [textButton]="true" [buttonName]="'English'" [ngClass]="{'unselected-lang' : _currentLang != 'en'}"
    (onClickEvent)="changeLang('en')" class="language-btn"></app-button>
  <app-button [textButton]="true" [buttonName]="'中文'" [ngClass]="{'unselected-lang' : _currentLang != 'cn'}"
    (onClickEvent)="changeLang('cn')" class="language-btn"></app-button>
  <app-button [textButton]="true" [buttonName]="'Bahasa Melayu'" [ngClass]="{'unselected-lang' : _currentLang != 'bm'}"
    (onClickEvent)="changeLang('bm')" class="language-btn"></app-button>

</div>
